/**
 * CopyableId - Wrapper component for ID values
 *
 * Pre-configured CopyableValue for displaying IDs (transaction, member, or generic)
 * with click-to-copy functionality.
 *
 * @example
 * ```tsx
 * <CopyableId id="abc123" type="transaction" />
 * <CopyableId id="user456" type="member" memberData={{ fullName: "John Doe", email: "john@example.com" }} />
 * ```
 */

import React from 'react';
import { CopyableValue } from './CopyableValue';
import type { CopyableIdProps } from './types';

export const CopyableId: React.FC<CopyableIdProps> = ({
  id,
  type = 'generic',
  memberData,
  onCopy,
  className,
}) => {
  // Determine label based on type
  const label = type === 'transaction' ? 'id' : type === 'member' ? 'member' : 'id';

  // Determine variant
  const variant = type === 'member' ? 'member' : 'id';

  return (
    <CopyableValue
      value={id}
      variant={variant}
      label={label}
      memberData={memberData}
      onCopy={onCopy}
      className={className}
    />
  );
};

export default CopyableId;
